import { render, staticRenderFns } from "./AIReview.vue?vue&type=template&id=09c580b6&scoped=true&"
import script from "./AIReview.vue?vue&type=script&lang=js&"
export * from "./AIReview.vue?vue&type=script&lang=js&"
import style0 from "./AIReview.vue?vue&type=style&index=0&id=09c580b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c580b6",
  null
  
)

export default component.exports